<template>
  <div>
    <router-view :key="moduleKey" v-if="moduleIsReady"/>
    <div v-else>Loading users...</div>
  </div>
</template>

<script>
// import { FETCH_USERS } from './store';

export default {
  name: 'RecordsModule',

  created() {
    this.bootstrap();
  },

  computed: {
    // users() {
    //   return this.$store.getters.users;
    // },

    moduleIsReady() {
      return true; // !!this.users;
    },

    moduleKey() {
      return 'sites';
    },
  },

  methods: {
    bootstrap() {
    //   try {
    //     await this.$store.dispatch(FETCH_USERS);
    //   } catch (err) {
    //     console.error('user accounts bootstrap err', err);
    //     if (err.message === 'Network Error') {
    //       this.$router.push({ name: 'NotFound' });
    //     } else {
    //       this.$router.push({ name: 'UnAuthorized' });
    //     }
    //   }
    },
  },
};
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
